import React, { useState,useEffect } from "react";
import "./WhoCanApply.css";
import AquireImg from "../assets/images/aquire-img.png";
const WhoCanApply = () => {
  return (
    <div className="architecture-section">
      <div className="architecture-container">
          <div className="robot-section">
            <div className="robot-img"><img src={AquireImg} className="tools-left" /></div>
            <div className="robot-content">
               <span>Focus on</span>
               <h2>Core Design <strong>& <br></br>Components</strong></h2> 
               <p><b>Gain comprehensive knowledge of advanced robotic system</b> architecture, along with a thorough understanding of the individual components that make up a  quadruped robot</p>
               <p>Dive deep into the engineering behind autonomous systems exploring the intricate hardware, advanced AI, and integrated sensors that power our <b>quadruped</b> robots.</p>
            </div>
          </div>
      </div>
    </div>
  );
};

export default WhoCanApply;
